/**
 * 共通i18n定数
 *
 * 複数のコンポーネントで使用される共通ワードを定義
 * 使用方法:
 *   import { COMMON_I18N } from '@app/i18n';
 *   protected readonly common = COMMON_I18N;
 */

export const COMMON_I18N = {
  // ボタン
  button: {
    cancel: $localize`:@@common.button.cancel:キャンセル`,
    submit: $localize`:@@common.button.submit:送信`,
    save: $localize`:@@common.button.save:保存`,
    delete: $localize`:@@common.button.delete:削除`,
    close: $localize`:@@common.button.close:閉じる`,
    update: $localize`:@@common.button.update:更新`,
    create: $localize`:@@common.button.create:作成`,
    edit: $localize`:@@common.button.edit:編集`,
    download: $localize`:@@common.button.download:ダウンロード`,
    upload: $localize`:@@common.button.upload:アップロード`,
    register: $localize`:@@common.button.register:登録`,
    confirm: $localize`:@@common.button.confirm:確認`,
    yes: $localize`:@@common.button.yes:はい`,
    no: $localize`:@@common.button.no:いいえ`,
  },

  // ラベル
  label: {
    name: $localize`:@@common.label.name:氏名`,
    email: $localize`:@@common.label.email:メールアドレス`,
    code: $localize`:@@common.label.code:コード`,
    sex: $localize`:@@common.label.sex:性別`,
    birthDate: $localize`:@@common.label.birthDate:生年月日`,
    age: $localize`:@@common.label.age:年齢`,
    createdAt: $localize`:@@common.label.createdAt:作成日`,
    date: $localize`:@@common.label.date:日付`,
    status: $localize`:@@common.label.status:ステータス`,
  },

  // ステータス
  status: {
    active: $localize`:@@common.status.active:有効`,
    inactive: $localize`:@@common.status.inactive:無効`,
    suspended: $localize`:@@common.status.suspended:停止`,
    pending: $localize`:@@common.status.pending:招待中`,
    available: $localize`:@@common.status.available:利用可能`,
  },

  // 性別
  sex: {
    male: $localize`:@@common.sex.male:男性`,
    female: $localize`:@@common.sex.female:女性`,
    other: $localize`:@@common.sex.other:その他`,
  },

  // メッセージ
  message: {
    loading: $localize`:@@common.message.loading:データを読み込んでいます`,
    saving: $localize`:@@common.message.saving:保存しています`,
    uploading: $localize`:@@common.message.uploading:アップロードしています`,
    registerSuccess: $localize`:@@common.message.registerSuccess:登録が完了しました`,
    registerError: $localize`:@@common.message.registerError:登録に失敗しました。再度お試しください`,
    updateSuccess: $localize`:@@common.message.updateSuccess:更新が完了しました`,
    updateError: $localize`:@@common.message.updateError:更新に失敗しました。再度お試しください`,
    deleteSuccess: $localize`:@@common.message.deleteSuccess:削除が完了しました`,
    deleteError: $localize`:@@common.message.deleteError:削除に失敗しました。再度お試しください`,
    error: $localize`:@@common.message.error:エラーが発生しました`,
  },

  // バリデーション
  validation: {
    required: $localize`:@@common.validation.required:必須項目です`,
    invalidEmail: $localize`:@@common.validation.invalidEmail:メールアドレスの形式が正しくありません`,
    invalidFormat: $localize`:@@common.validation.invalidFormat:形式が正しくありません`,
  },

  // ナビゲーション
  nav: {
    menu: $localize`:@@common.nav.menu:メニュー`,
    home: $localize`:@@common.nav.home:ホーム`,
    logout: $localize`:@@common.nav.logout:ログアウト`,
    admin: $localize`:@@common.nav.admin:管理者`,
    manual: $localize`:@@common.nav.manual:マニュアル`,
    support: $localize`:@@common.nav.support:サポート`,
  },

  // ページネーター
  paginator: {
    itemsPerPage: $localize`:@@common.paginator.itemsPerPage:1ページあたりの件数`,
    nextPage: $localize`:@@common.paginator.nextPage:次へ`,
    previousPage: $localize`:@@common.paginator.previousPage:前へ`,
    firstPage: $localize`:@@common.paginator.firstPage:最初のページ`,
    lastPage: $localize`:@@common.paginator.lastPage:最後のページ`,
  },
} as const;

export type CommonI18n = typeof COMMON_I18N;
